/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.recoverPassword.controllers', [
  'ui.router',
  'acme.common.directive.notice',
  'acme.common.service.api',
  'acme.common.service.validate',
  'acme.common.factory.notice'
])

.controller('RecoverPasswordController', ['$scope', '$state', '$log', 'ApiService', 'ValidateService', 'NoticeFactory', function($scope, $state, $log, ApiService, ValidateService, NoticeFactory) {

    $scope.recoverPassword = {

      isSubmitted: false,

      email: '',

      notice: {},

      init: function() {
        this.notice = new NoticeFactory();
      },

      done: function() {
        $state.go('login.default');
      },

      showForm: function() {
        console.log('RecoverPasswordController::showForm: ', (!this.notice.isLoaded && !this.notice.isLoading)  || this.notice.showErrors , !this.notice.isLoading , this.notice.showErrors);
        return ((!this.notice.isLoaded && !this.notice.isLoading) || this.notice.showErrors);
      },

      showDone: function() {
        console.log('RecoverPasswordController::showDone: ', this.notice.isLoaded && !this.notice.showErrors , this.notice.isLoaded, !this.notice.showErrors);

        return (this.notice.isLoaded && !this.notice.showErrors);
      },

      isValidEmail: function() {
        if (this.isSubmitted) {
          return ValidateService.validate([
            {
              email: this.email
            }
          ]);
        }
      },

      complete: function() {

        this.isSubmitted = true;

        if (ValidateService.validate([{
          email: this.email
        }])) {
          this.notice.startLoad();
          ApiService.user.recover(this.email).then(this.success, this.error);
        }else{
          this.notice.showErrorMessages([
            { message: 'Please correct the errors below.' }
          ]);
        }
      },

      success: function(response, status, headers, config) {
        $scope.recoverPassword.notice.endLoad();
        $scope.recoverPassword.notice.hideMessages();
      },

      error: function(response, status, headers, config) {

        $scope.recoverPassword.notice.endLoad();

        $scope.recoverPassword.notice.showErrorMessages([
          { message: response.data.error }
        ]);
      }

    };

    $scope.recoverPassword.init();


}]);